export default {
  title: 'Estadísticas',
  ekrmTab: 'EKRM',
  referenceModelsTab: 'Modelos de Referencia',
  export: 'Exportar',
  headerModel: 'Modelo',
  headerDateCreated: 'Fecha de Creación',
  headerCreatedBy: 'Creado Por',
  headerReference: 'Referencia',
  headerCountry: 'País',
  headerReferenceId: 'ID de Referencia',
  headerCategory: 'Categoría',
  headerCustomModelsCount: 'Cantidad de Modelos Personalizados',
  headerCountLast90Days: 'Cantidad Últimos 90 días'
}
